export const SHOW_MODAL = 'SHOW_MODAL'
export const DISMISS_MODAL = 'DISMISS_MODAL'
export const NAVIGATE_SIDEBAR = 'NAVIGATE_SIDEBAR'
export const TOGGLE_MENU = 'TOGGLE_MENU'
